import { useEffect, useState } from 'react';

export function MediaPreview({ src, type, name }: { src: string; type: string; name: string }) {
  if (type.startsWith('image/'))
    return (
      <img
        src={src}
        alt={name}
        loading="lazy"
        style={{ maxWidth: '100%', maxHeight: 300, objectFit: 'contain' }}
      />
    );
  if (type.startsWith('video/'))
    return (
      <video
        src={src}
        controls
        preload="metadata"
        aria-label={name}
        style={{ maxWidth: '100%', maxHeight: 360 }}
      >
        Download the file to view this video.
      </video>
    );
  return null;
}

export function LocalMediaPreview({ file }: { file: File }) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    const url = URL.createObjectURL(file);
    setSrc(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);
  return src ? <MediaPreview src={src} type={file.type} name={file.name} /> : null;
}
